module.exports = __webpack_public_path__ + "img/logo-rackperu-desktop.54c7de44.svg";